// extracted by mini-css-extract-plugin
export default {"Left_dynamic_banner":"DynamicBanner_Left_dynamic_banner__Semp6"};